<div class="ps-text-input">
  @if (label()) {
    <label [for]="id()" class="form-label">
      {{ label() }}
      @if (required()) {
        <span class="text-danger">*</span>
      }
    </label>
  }

  <input
    [id]="id()"
    [name]="name()"
    [class]="inputClasses()"
    [type]="type()"
    [placeholder]="placeholder()"
    [value]="value()"
    [required]="required()"
    [disabled]="disabled()"
    [readonly]="readonly()"
    [attr.maxlength]="maxLength()"
    [attr.minlength]="minLength()"
    [attr.aria-invalid]="isInvalid()"
    [attr.aria-required]="required()"
    [attr.aria-label]="ariaLabel() || label()"
    [attr.aria-describedby]="isInvalid() ? ariaDescribedBy() : null"
    [attr.data-cy]="id()"
    (input)="onInput($event)"
    (blur)="onBlur()"
  />

  @if (isInvalid() && errors().length > 0) {
    <div [id]="ariaDescribedBy()" class="invalid-feedback">
      @for (error of errors(); track error) {
        <span class="error">{{ error.message }}</span>
      }
    </div>
  }
</div>
